export enum EkycStatus {
  NotEKYCed = 0,
  Verified = 1,
  Failed = 2,
  ReKYC = 3,
  NotRequired = 4,
  Pending = 5,
  InProgress = 6,
}
